import { render } from "./packone.vue?vue&type=template&id=2b0f10ef&scoped=true"
import script from "./packone.vue?vue&type=script&lang=js"
export * from "./packone.vue?vue&type=script&lang=js"

import "./packone.vue?vue&type=style&index=0&id=2b0f10ef&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0f10ef"]])

export default __exports__